import { useEffect, useState } from 'react';
import { accountAlertsAPI } from './api';

const EVENT = 'alerts-badge-changed';
let cached = 0;
let lastFetch = 0;

const refresh = async (force = false) => {
  if (!force && Date.now() - lastFetch < 60000) return cached;
  lastFetch = Date.now();
  try {
    const d = await accountAlertsAPI.badge();
    cached = d.unseen || 0;
  } catch { cached = 0; }
  window.dispatchEvent(new Event(EVENT));
  return cached;
};

// Alerts e-mailed since the last visit of « Mes alertes » (red counter on the account icon)
export const alertsBadge = {
  refresh,
  markSeen: async () => {
    try { await accountAlertsAPI.seen(); } catch { /* ignore */ }
    cached = 0;
    lastFetch = Date.now();
    window.dispatchEvent(new Event(EVENT));
  },
};

export const useAlertsBadge = (enabled) => {
  const [n, setN] = useState(cached);
  useEffect(() => {
    if (!enabled) return undefined;
    const h = () => setN(cached);
    window.addEventListener(EVENT, h);
    refresh();
    const id = setInterval(() => refresh(true), 120000);
    return () => { window.removeEventListener(EVENT, h); clearInterval(id); };
  }, [enabled]);
  return enabled ? n : 0;
};
